import React, { useState } from 'react';
import { PopupButton } from 'react-calendly';
import { CONTACT_US_CALENDLY_URL } from '../../../../utils/constant/constants';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';
import package2 from '../../../../assets/marketing/DrawingRoom2.webp';
import { featureIcons } from '../constants';
import FeatureItem from './FeatureItem';

const BrokeragePackage = () => {
	const [showFullContent, setShowFullContent] = useState(false);

	return (
		<div
			id='brokerage-package'
			className='md:ml-[20px] w-full max-w-[487px] relative'>
			{/* Mobile-only header */}
			<div className='md:hidden text-center mb-4 mt-8'>
				<h4 className='font-canela-trial text-[20px] font-medium uppercase text-clientWhite'>
					For Brokerages and Teams
				</h4>
			</div>

			<div className='bg-[#2A2A2A] rounded-t-[13px] border-t-4 border-[rgba(204,_29,_185,_0.7)]'>
				<img
					src={package2}
					alt='Brokerage Marketing Package'
					loading='lazy'
					className='w-full max-w-[487px] h-auto sm:h-auto h-[180px] rounded-t-[13px] rounded-b-none object-cover m-[0] md:mt-[-260px]'
				/>
				<div className='px-6 sm:px-6 px-4 py-4 flex flex-col h-full'>
					<div className='mt-[20px] w-full'>
						<p className='font-lejour text-[clamp(16px,_3vw,_22px)] font-normal leading-[34.2px] sm:leading-[34.2px] leading-[28px] uppercase m-0 text-clientWhite'>
							Brokerage Marketing and Strategy
							<span className='block font-glacial text-[clamp(16px,_3vw,_22px)] font-bold leading-[24.2px] m-0 text-[rgba(204,_29,_185,_0.9)]'>
								Let's Talk
								<span className='font-bold text-clientWhite text-[clamp(16px,_3vw,_22px)] ml-2'>
									About Your Needs
								</span>
							</span>
						</p>
					</div>

					<div className='flex-grow mb-[10px] mt-[20px] h-auto w-full text-[#CFCFCF]'>
						<p className='mb-[20px] font-glacial text-[18px] sm:text-[18px] text-[16px] font-normal leading-[25.2px] sm:leading-[25.2px] leading-[22px] text-[#CFCFCF]'>
							For boutique brokerages aiming to scale with a dedicated marketing
							director.
						</p>

						<FeatureItem
							icon={featureIcons.business}
							text='Marketing strategy assessment'
						/>
						<FeatureItem
							icon={featureIcons.design}
							text='Marketing director services'
						/>

						<div>
							{showFullContent ? (
								<React.Fragment>
									<FeatureItem
										icon={featureIcons.design}
										text='Development of new marketing content across multiple channels:'
									/>

									<FeatureItem
										icon={featureIcons.check}
										text='Email campaigns'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Social media marketing'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Direct mail outreach'
										indent={true}
									/>
									<FeatureItem
										icon={featureIcons.check}
										text='Digital ad strategy'
										indent={true}
									/>

									<FeatureItem
										icon={featureIcons.design}
										text='Branding refinement & creation of brokerage-wide marketing templates'
									/>
									<FeatureItem
										icon={featureIcons.clients}
										text='Agent growth strategy & marketing consultations'
									/>
								</React.Fragment>
							) : (
								''
							)}
						</div>

						<button
							type='button'
							onClick={() => setShowFullContent(!showFullContent)}
							className='flex items-center text-clientWhite text-[14px] font-bold mt-[20px] leading-[16.8px] cursor-pointer hover:text-[rgba(204,_29,_185,_0.8)] transition-colors'>
							{showFullContent ? 'VIEW LESS DETAILS' : 'VIEW ALL DETAILS'}

							{showFullContent ? (
								<GoArrowLeft className='text-[rgba(204,_29,_185,_0.8)] text-[20px] ml-2 mb-[2px]' />
							) : (
								<GoArrowRight className='text-[rgba(204,_29,_185,_0.8)] text-[20px] ml-2 mb-[2px]' />
							)}
						</button>

						<div className='mt-auto pt-6 flex justify-center'>
							<PopupButton
								className='font-glacial my-[18px] bg-[rgba(204,_29,_185,_0.8)] hover:bg-[rgba(204,_29,_185,_0.7)] transition-colors rounded-[6px] mb-[50px] h-[60px] sm:h-[60px] h-[50px] w-full text-[18px] sm:text-[18px] text-[16px] smallView:text-[15px] font-bold leading-[28px] text-clientWhite cursor-pointer'
								url={CONTACT_US_CALENDLY_URL}
								rootElement={document.getElementById('root')}
								text='Grow Your Brokerage with a Marketing Director'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default BrokeragePackage;
